"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LicenseManager = undefined;

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _license = require("../../redux/modules/license");

var _Table = require("../../components/table/Table");

var _Table2 = _interopRequireDefault(_Table);

var _InvitationList = require("../../components/license/InvitationList");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LicenseManager = exports.LicenseManager = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LicenseManager, _Component);

  function LicenseManager(props) {
    (0, _classCallCheck3.default)(this, LicenseManager);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LicenseManager.__proto__ || (0, _getPrototypeOf2.default)(LicenseManager)).call(this, props));

    _this.state = {
      newInvitations: {},
      orderTableSettings: {
        headers: ["Nimi", "Sähköposti", "Puhelin", "pvm"],
        format: [{
          cell: 4,
          type: "hidden"
        }, {
          cell: 5,
          type: "hidden"
        }, {
          cell: 6,
          type: "hidden"
        }, {
          cell: 7,
          type: "hidden"
        }, {
          cell: 8,
          type: "hidden"
        }, {
          cell: 9,
          type: "hidden"
        }, {
          cell: 10,
          type: "hidden"
        }], combineCells: [{
          cell: 0,
          type: "right"
        }]
      },
      InvitationTableSettings: {
        headers: ["Nimi", "Sähköposti", "Puhelin", "Pvm"],
        format: [{
          cell: 2,
          type: "booleanImage"
        }, {
          cell: 4,
          type: "booleanImage"
        }, {
          cell: 5,
          type: "dateTime"

        }],
        combineCells: [{
          cell: 1,
          type: "right"
        }, {
          cell: 3,
          type: "right"
        }]
      }
    };
    return _this;
  }

  (0, _createClass3.default)(LicenseManager, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.license.sendDriverLicensesSuccess) {
        if (this.props.license.driverLicenseInvitation !== prevProps.license.driverLicenseInvitation) {
          var user = this.props.user;

          var userCompanyId = 0;
          if (user) {
            userCompanyId = Number(user.company_id);
          }

          if (userCompanyId > 0) {
            this.props.getDriverLicenses(userCompanyId);
          }

          this.setState({
            newInvitations: [].concat((0, _toConsumableArray3.default)(this.state.newInvitations), [this.props.license.driverLicenseInvitation])
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var user = this.props.user;

      var userCompanyId = 0;
      if (user) {
        userCompanyId = Number(user.company_id);
      }

      if (userCompanyId > 0) {
        this.props.getDriverLicenses(userCompanyId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var user = this.props.user;

      var userCompanyId = 0;
      if (user) {
        userCompanyId = Number(user.company_id);
      }

      return _react2.default.createElement(
        "div",
        { className: "container licenceManager" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Lisenssien hallinta" }),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
              "div",
              { className: "col col-xs-12" },
              _react2.default.createElement(
                "h1",
                { className: "h2" },
                " Kuljettajien lisenssit "
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "row" },
            this.props.license.driverLicenses ? this.createOrderInfo() : ""
          )
        )
      );
    }
  }, {
    key: "createOrderTable",
    value: function createOrderTable(settings, data) {
      return _react2.default.createElement(_Table2.default, {
        data: data,
        settings: settings
      });
    }
  }, {
    key: "createInvitationTable",
    value: function createInvitationTable(settings, data) {
      return _react2.default.createElement(_Table2.default, {
        data: data,
        settings: settings
      });
    }
  }, {
    key: "createInvitationInfo",
    value: function createInvitationInfo() {
      return _react2.default.createElement(
        "div",
        null,
        "TODO"
      );
    }
  }, {
    key: "createOrderInfo",
    value: function createOrderInfo() {
      var _this2 = this;

      var user = this.props.user;
      var company = this.props.company;

      var allOrders = this.props.license.driverLicenses.allLicenseOrders;
      if ((0, _keys2.default)(allOrders).length < 1) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h3",
            { className: "h3" },
            " Ei tilauksia "
          )
        );
      }
      var allLicenseInvitations = this.props.license.driverLicenses.allLicenseInvitations;

      var distinctOrders = [].concat((0, _toConsumableArray3.default)(new _set2.default(allOrders.map(function (x) {
        return x.user_license_order_id;
      }))));

      return distinctOrders.map(function (id, index) {
        var invitationData = allLicenseInvitations.filter(function (invitation) {
          return invitation.license_order_id == id;
        });

        var orderData = allOrders.filter(function (order) {
          return order.user_license_order_id == id;
        });
        var quantityOrdered = 0;
        var hasLincensesInUse = false;
        var quantityAvailable = 0;
        var orderId = 0;
        var token = "";
        var validUntil = "";
        var quantityUsed = 0;

        if ((0, _keys2.default)(orderData).length > 0 && orderData[0].user_id) {
          hasLincensesInUse = true;
        }
        quantityOrdered = orderData[0].quantity;
        quantityAvailable = quantityOrdered - (0, _keys2.default)(orderData).length;
        quantityUsed = (0, _keys2.default)(orderData).length;
        orderId = orderData[0].user_license_order_id;
        validUntil = orderData[0].valid_until;
        token = orderData[0].invitation_token;

        if (!orderData[0].user_id) {
          quantityAvailable = quantityAvailable + 1;
          quantityUsed = quantityUsed - 1;
        }
        var invitationsSent = _this2.props.license.driverLicenses.allLicenseInvitations.length;
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          "Tilausnumero ",
          orderId,
          " Tilattu ",
          quantityOrdered,
          " lisenssi\xE4. ",
          _react2.default.createElement("br", null),
          "Lisenssej\xE4  k\xE4ytetty ",
          quantityUsed,
          ", j\xE4ljell\xE4 ",
          quantityAvailable,
          ". lisenssit voimassa ",
          (0, _moment2.default)(validUntil).format("D.M.YYYY"),
          " asti",
          quantityUsed > 0 && _this2.createOrderTable(_this2.state.orderTableSettings, orderData),
          _react2.default.createElement(
            "h2",
            { className: "h4 form-title" },
            "Kutsutut kuljettajat  "
          ),
          invitationsSent > 0 ? _this2.createInvitationTable(_this2.state.InvitationTableSettings, invitationData) : "Ei kutsuttuja kuljettajia",
          _react2.default.createElement(
            "h2",
            { className: "h4 form-title" },
            "Kutsu uusia kuljettajia  "
          ),
          _react2.default.createElement(_InvitationList.InvitationList, {
            sendDriverLicenseInvitation: _this2.props.sendDriverLicenseInvitation,
            token: token,
            orderId: orderId,
            sender: user })
        );
      });
    }
  }]);
  return LicenseManager;
}(_react.Component), _class.propTypes = {
  pushRoute: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    license: state.license

  };
}, {
  pushRoute: _reactRouterRedux.push,
  getDriverLicenses: _license.getDriverLicenses,
  sendDriverLicenseInvitation: _license.sendDriverLicenseInvitation
}) /* (reduxForm({
      form: 'feedback',
      fields: [
        'email',
        'phone',
        'name',
        'message'
      ],
      validate: feedbackValidator
    }
    
    ) */(LicenseManager); // );


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/License/LicenseManager.js
 ** module id = 1217
 ** module chunks = 0
 **/